import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ce20848"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "modal"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "body"
}
const _hoisted_6 = { class: "gate-no-wrapper" }
const _hoisted_7 = { class: "gate-no-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        ($setup.shouldShowModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("header", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString($props.busStopName), 1 /* TEXT */),
                _createVNode($setup["InlineSvg"], {
                  class: "close-btn",
                  src: require('@/assets/icons/x-icon.svg'),
                  alt: "닫기",
                  onClick: $setup.closeModal
                }, null, 8 /* PROPS */, ["src"])
              ]),
              ($setup.layoutInfo)
                ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.layoutInfo.layoutList[0], (row, rowIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `row-${rowIndex}`,
                        class: _normalizeClass(["layout-row", { 'empty-row': $setup.isRowEmpty(row) }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (column, columnIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `column-${columnIndex}`,
                            class: _normalizeClass(["layout-column", {
                primary: $setup.isGateNo(column.gateNo),
                'empty-column': !column.gateNo?.length,
              }])
                          }, _toDisplayString(column.gateNo), 3 /* TEXT, CLASS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, " 탑승위치 : " + _toDisplayString($setup.convertToRangeGateNames($setup.layoutInfo?.gateNo ?? [])), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}